<template>
	<modal-box @close="onClose" :header="header" :subHeader="$t('headers.general.pillbox')">
		<span slot="sub-header" class="sub-header">Pill Box</span>
		<span slot="header" class="header">{{ action | capitalize }} Pill</span>
		<spinner v-if="form.loading" class="spinner"/>
		<form @submit.prevent="validateAndSubmit">
			<input-shape v-model="model.type" :color="model.color" name="pill_shape" :placeholder="$t('labels.general.shape')" rules="required" class="form-group-shape"/>
			<input-color v-model="model.color" name="pill_color" :placeholder="$t('labels.general.color')" rules="required" class="form-group-color"/>
			<input-text v-model="model.name" name="pill_name" :placeholder="$t('labels.general.name')" rules="required" class="form-group-name"/>
			<input-date v-model="model.date_start" name="pill_start" :placeholder="$t('labels.general.start_date')" rules="required" class="form-group-start"/>
			<input-date v-model="model.date_end" name="pill_end" :placeholder="$t('labels.general.end_date')" rules="required" class="form-group-end"/>
			<input-week v-model="model.week" name="pill_week" :placeholder="$t('labels.general.week')" rules="required" class="form-group-week"/>
			<input-time v-model="model.hour" name="pill_hour" :placeholder="$t('labels.general.hour')" rules="required" class="form-group-hour"/>
			<input-text v-model="model.dose" name="pill_dose" :placeholder="$t('labels.general.dose')" rules="required" class="form-group-dose"/>
			<div class="form-group-actions">
				<button-submit-icon-text :loading="form.loading" icon="save">{{ $t('buttons.general.save') }}</button-submit-icon-text>
			</div>
		</form>
	</modal-box>
</template>

<script>
import InputColor from './InputColor'
import InputShape from './InputShape'
import InputWeek from './InputWeek'
import Pill from '@/classes/Pill'
export default {
	components: {
		InputColor,
		InputShape,
		InputWeek
	},
	props: [
		'user_uid',
		'watch_id',
		'pill_id',
		'data',
		'action'
	],
	data () {
		return {
			form: {
				loading: false,
				error: null
			},
			model: {
				type: '',
				color: '',
				name: '',
				date_start: '',
				date_end: '',
				hour: '',
				week: '',
				dose: ''
			}
		}
	},
	computed: {
		header () {
			return this.action === 'add' ? this.$t('headers.general.add_pill') : this.$t('headers.general.edit_pill')
		}
	},
	methods: {
		validateAndSubmit () {
			this.$validator.validateAll().then(result => {
				if (result) this.submit()
			})
		},
		submit () {
			switch (this.action) {
				case 'add':
					this.addPill()
					break
				case 'edit':
					this.editPill()
					break
				default:
					this.$log.warn('watch pillbox', 'action not set')()
			}
		},
		getPill () {
			this.form.loading = true
			this.$api.pillbox2.getById(this, this.user_uid, this.watch_id, this.pill_id).then(response => {
				this.$log.info('watch pillbox', 'pillbox.getById OK', response)()
				this.setModel(response.body)
			}).catch(error => {
				this.$log.error('watch pillbox', 'pillbox.getById ERROR', error)()
				this.form.error = error
			}).finally(() => {
				this.form.loading = false
			})
		},
		addPill () {
			this.form.loading = true
			this.$api.pillbox2.add(this, this.user_uid, this.watch_id, this.model).then(response => {
				this.$log.info('watch pillbox', 'pillbox.add OK', response)()
				this.onClose()
			}).catch(error => {
				this.$log.error('watch pillbox', 'pillbox.add ERROR', error)()
				this.form.error = error
			}).finally(() => {
				this.form.loading = false
			})
		},
		editPill () {
			this.form.loading = true
			this.$api.pillbox2.edit(this, this.user_uid, this.watch_id, this.model).then(response => {
				this.$log.info('watch pillbox', 'pillbox.edit OK', response)()
				this.onClose()
			}).catch(error => {
				this.$log.error('watch pillbox', 'pillbox.edit ERROR', error)()
				this.form.error = error
			}).finally(() => {
				this.form.loading = false
			})
		},
		setModel (data) {
			this.model = {
				id: data.id,
				name: data.name,
				type: data.type,
				color: data.color,
				date_start: data.date_start,
				date_end: data.date_end,
				week: data.week,
				hour: this.$moment(data.hour, 'HH:mm:ss').format('HH:mm'),
				dose: data.dose
			}
		},
		onClose () {
			this.$router.go(-1)
		}
	},
	mounted () {
		if (this.action === 'add') {
			this.model.date_start = this.$moment().format('YYYY-MM-DD')
			this.model.date_end = this.$moment().add(1, 'd').format('YYYY-MM-DD')
			this.model.hour = this.$moment().format('HH:mm')
		}
		if (this.action === 'edit') {
			if (this.data === undefined) {
				this.getPill()
			} else {
				this.setModel(this.data)
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/pillboxV2/PillForm.vue